import { Suspense, useState } from "react";
import { isStaging } from "../config/env";
import DelayedLoadingFallback from "utils/DelayedLoadingFallback";
import { Outlet } from "react-router-dom";

const STAGING_PASSWORD = process.env.REACT_APP_STAGING_PASSWOR;

const StagingGate = () => {
  const [allowed, setAllowed] = useState(
    !isStaging || sessionStorage.getItem("staging_auth") === "true",
  );
  const [input, setInput] = useState("");
  const [error, setError] = useState(false);

  if (allowed)
    return (
      <Suspense fallback={<DelayedLoadingFallback delay={500} />}>
        <Outlet />
      </Suspense>
    );

  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      width: "100vw",
      backgroundColor: "#f4f7f6",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      padding: "20px",
      boxSizing: "border-box",
    },
    card: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      maxWidth: "400px",
      padding: "40px 30px",
      borderRadius: "16px",
      backgroundColor: "#ffffff",
      boxShadow:
        "0 10px 25px rgba(0, 0, 0, 0.05), 0 2px 4px rgba(0, 0, 0, 0.02)",
      boxSizing: "border-box",
      textAlign: "center",
    },
    title: {
      margin: "0 0 8px 0",
      color: "#1a1a1a",
      fontSize: "24px",
      fontWeight: "600",
      letterSpacing: "-0.5px",
    },
    subtitle: {
      margin: "0 0 24px 0",
      color: "#666666",
      fontSize: "14px",
    },
    input: {
      width: "100%",
      padding: "14px 16px",
      fontSize: "16px", // Prevents iOS auto-zoom on focus
      borderRadius: "8px",
      border: error ? "2px solid #ff4d4f" : "1px solid #e0e0e0",
      backgroundColor: "#fafafa",
      outline: "none",
      transition: "all 0.2s ease",
      boxSizing: "border-box",
      marginBottom: "16px",
    },
    button: {
      width: "100%",
      padding: "14px",
      fontSize: "16px",
      fontWeight: "600",
      color: "#ffffff",
      backgroundColor: "#007aff", // Modern iOS blue
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      transition: "background-color 0.2s ease",
    },
    errorText: {
      color: "#ff4d4f",
      fontSize: "14px",
      margin: "12px 0 0 0",
      fontWeight: "500",
    },
  };

  const handleAuth = () => {
    if (input === STAGING_PASSWORD) {
      sessionStorage.setItem("staging_auth", "true");
      setAllowed(true);
    } else {
      setError(true);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Staging Environment</h2>
        <p style={styles.subtitle}>Please enter your access password below.</p>

        <input
          type="text" // 'text' combined with inputmode offers better cross-browser consistency
          inputmode="numeric" // Triggers the modern iOS numeric keypad
          pattern="[0-9]*" // Serves as a fallback for older iOS versions
          placeholder="Enter staging password"
          value={input}
          style={styles.input}
          onChange={(e) => {
            if (error) setError(false);
            setInput(e.target.value);
          }}
          onKeyDown={(e) => e.key === "Enter" && handleAuth()}
        />

        <button
          onClick={handleAuth}
          style={styles.button}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#0062cc")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#007aff")
          }
        >
          Enter
        </button>

        {error && (
          <p style={styles.errorText}>✕ Incorrect password. Try again.</p>
        )}
      </div>
    </div>
  );
};

export default StagingGate;
